/** @jsx jsx */
import { jsx, Styled, useThemeUI } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import SectionWrapper from "./section-wrapper"

const Hero = () => {
  const { theme } = useThemeUI()
  const data = useStaticQuery(graphql`
    query {
      welcomeImage: file(relativePath: { eq: "header.png" }) {
        childImageSharp {
          fluid(maxWidth: 1024) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <SectionWrapper bg="secondary">
      <div
        sx={{
          display: "grid",
          gridTemplateColumns: [
            "1fr",
            "180px minmax(auto, 400px)",
            "200px minmax(400px, 600px)",
          ],
          gridGap: 4,
          alignItems: "center",
          justifyItems: "center",
          justifyContent: "center",
        }}
      >
        <div>
          <Styled.p
            sx={{
              fontSize: [4, null, null, 5, null],
              fontFamily: "heading",
              m: 0,
              display: "inline",
            }}
          >
            ...a string quintet with a twist...
          </Styled.p>
        </div>
        <Img
          sx={{
            width: ["100%", "100%", null, null, null],
            height: ["100%", "100%", null, null, null],
          }}
          fluid={data.welcomeImage.childImageSharp.fluid}
          alt="United Intonations"
          imgStyle={{ objectFit: "contain" }}
        />
      </div>
    </SectionWrapper>
  )
}

export default Hero
